export const TEST = 'TEST';
export const SET_AUTHORIZATION_STATUS = 'SET_AUTHORIZATION_STATUS';

export const GET_LATEST_NEWS_STARTED = 'GET_LATEST_NEWS_STARTED';
export const GET_LATEST_NEWS_SUCCESS = 'GET_LATEST_NEWS_SUCCESS';
export const GET_LATEST_NEWS_FAILURE = 'GET_LATEST_NEWS_FAILURE';

export const GET_POST_STARTED = 'GET_POST_STARTED';
export const GET_POST_SUCCESS = 'GET_POST_SUCCESS';
export const GET_POST_FAILURE = 'GET_POST_FAILURE';

export const GET_NONCE_STARTED = 'GET_NONCE_STARTED';
export const GET_NONCE_SUCCESS = 'GET_NONCE_SUCCESS';
export const GET_NONCE_FAILURE = 'GET_NONCE_FAILURE';

export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGIN_WITH_HONEE_STARTED = 'LOGIN_WITH_HONEE_STARTED';
export const LOGIN_WITH_HONEE_SUCCESS = 'LOGIN_WITH_HONEE_SUCCESS';
export const LOGIN_WITH_HONEE_FAILURE = 'LOGIN_WITH_HONEE_FAILURE';

export const SEND_IDO_FORM_STARTED = 'SEND_IDO_FORM_STARTED';
export const SEND_IDO_FORM_SUCCESS = 'SEND_IDO_FORM_SUCCESS';
export const SEND_IDO_FORM_FAILURE = 'SEND_IDO_FORM_FAILURE';





